import { useEffect, useState } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import TokenomicsSection from './components/TokenomicsSection';
import RoadmapSection from './components/RoadmapSection';
import CommunitySection from './components/CommunitySection';
import WhitepaperSection from './components/WhitepaperSection';
import AudioToggle from './components/AudioToggle';

export default function HomePage() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-[#0a0e27] overflow-hidden">
      <AudioToggle />
      <HeroSection scrollY={scrollY} />
      <AboutSection />
      <TokenomicsSection />
      <RoadmapSection />
      <CommunitySection />
      <WhitepaperSection />
    </div>
  );
}
